import React, { useEffect, useState } from 'react';
import "./Home_page_product5.css";
import { useNavigate } from 'react-router-dom';

function Home_page_product5() {

  const [products, setProducts] = useState([
    {
      url: 'https://khoslaslider.s3.ap-south-1.amazonaws.com/uploads/2025/02/AC-Mar.png',
      search: 'Godrej AC'
    },
    {
      url: 'https://khoslaslider.s3.ap-south-1.amazonaws.com/uploads/2025/02/TV-Mar-1.png',
      search: 'Whirlpool Refrigerator'
    },
    {
      url: 'https://khoslaslider.s3.ap-south-1.amazonaws.com/uploads/2025/02/TV-Mar.png',
      search: 'LG TV'
    },
    {
      url: 'https://khoslaslider.s3.ap-south-1.amazonaws.com/uploads/2025/02/MCO-Mar-1.png',
      search: 'Samsung Washing Machine'
    },
    {
      url: 'https://khoslaslider.s3.ap-south-1.amazonaws.com/uploads/2025/02/MCO-Mar.png',
      search: 'IFB Microwave Oven'
    }]);
  const navigate = useNavigate();
  // async function fetchProducts() {
  //   try {
  //     const response = await fetch('https://qixve8qntk.execute-api.ap-south-1.amazonaws.com/dev/excel-data', {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //       body: JSON.stringify({
  //         queryStringParameters: {
  //           field: "Categories",
  //           value: category
  //         }
  //       }),
  //     });
  //     const data = await response.json();
  //     const cleanedBody = data.body.replace(/NaN/g, 'null');
  //     const parsedData = JSON.parse(cleanedBody);
  //     return parsedData;

  //   } catch (error) {
  //     console.log("Error fetching data:", error);
  //   }
  // }

  // useEffect(() => {
  //   async function fetchData() {
  //     const products = await fetchProducts();
  //     console.log(products);
  //     setProducts(products?.slice(0, 6));
  //   }

  //   fetchData();
  // }, [category]);
  return (
    <div className="Home_page_product5_container">
      <h4>Khosla Electronics Best Sellers</h4>
      <div className="Home_page_product5_product_grid">
        {products?.map((product) => (
          <img src={product.url} className="img-fluid" onClick={() => navigate(`/search/${product.search}`)}/>
        ))}
      </div>
    </div>
  );
}


export default Home_page_product5;